import React from "react";
import "./contactheader.css";

function Contactheader() {
  return (
    <div className="contactHeader">
      <h1>Feel free to reach out </h1>
    </div>
  );
}

export default Contactheader;
